module.exports = __webpack_public_path__ + "static/gili-Optimized.35a3d304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client-screens/gili-Optimized.png
// module id = 608
// module chunks = 213720915766396